module.exports = __webpack_public_path__ + "img/20190812162831826.1f8f2a4a.png";